'use client';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import { keyboardFocusOutline } from '../../mixins/keyboardFocus.js';
import { media } from '../../mixins/media.js';
import { spacing } from '../../mixins/spacing.js';
import '../Icons/AlignStartHorizontalIcon.js';
import '../Icons/ArchiveIcon.js';
import '../Icons/ArrowDownIcon.js';
import '../Icons/ArrowLeftBottomIcon.js';
import '../Icons/ArrowLeftIcon.js';
import '../Icons/ArrowLeftTopIcon.js';
import '../Icons/ArrowRightBottomIcon.js';
import '../Icons/ArrowRightIcon.js';
import '../Icons/ArrowRightTopIcon.js';
import '../Icons/BagIcon.js';
import '../Icons/BasketIcon.js';
import '../Icons/BellFilledIcon.js';
import '../Icons/BellNotificationIcon.js';
import '../Icons/BellOutlineIcon.js';
import '../Icons/BinocularsIcon.js';
import '../Icons/BlocksIcon.js';
import '../Icons/BoltIcon.js';
import '../Icons/BookIcon.js';
import '../Icons/BookmarkAddFilledIcon.js';
import '../Icons/BookmarkAddOutlineIcon.js';
import '../Icons/BookmarkIcon.js';
import '../Icons/BookOpenedIcon.js';
import '../Icons/BoxAltIcon.js';
import '../Icons/BusinessIcon.js';
import '../Icons/CalendarIcon.js';
import '../Icons/CancelIcon.js';
import '../Icons/CardsIcon.js';
import '../Icons/ChatAltIcon.js';
import '../Icons/ChatIcon.js';
import '../Icons/CheckboxIcon.js';
import '../Icons/CheckCirlcleFilledIcon.js';
import '../Icons/CheckSquareIcon.js';
import '../Icons/ChevronDoubleLeftIcon.js';
import '../Icons/ChevronDoubleRightIcon.js';
import '../Icons/ChevronDownIcon.js';
import { ChevronLeftIcon } from '../Icons/ChevronLeftIcon.js';
import '../Icons/ChevronRightIcon.js';
import '../Icons/ChevronUpIcon.js';
import '../Icons/ClipboardEditIcon.js';
import '../Icons/ClipboardIcon.js';
import '../Icons/CloseIcon.js';
import '../Icons/CollapseIcon.js';
import '../Icons/ControlsIcon.js';
import '../Icons/ControlsVerticalAltIcon.js';
import '../Icons/CopyIcon.js';
import '../Icons/CutIcon.js';
import '../Icons/DangerIcon.js';
import '../Icons/DownloadCloudIcon.js';
import '../Icons/DownloadIcon.js';
import '../Icons/DownloadPdfIcon.js';
import '../Icons/DrawerOpenIcon.js';
import '../Icons/EllipsisIcon.js';
import '../Icons/EllypsisVerticalIcon.js';
import '../Icons/EnvelopeIcon.js';
import '../Icons/ErrorIcon.js';
import '../Icons/ExitIcon.js';
import '../Icons/ExpandIcon.js';
import '../Icons/ExternalLinkIcon.js';
import '../Icons/EyeCrossedIcon.js';
import '../Icons/EyeIcon.js';
import '../Icons/FacebookIcon.js';
import '../Icons/FavouriteIcon.js';
import '../Icons/FileBadgeIcon.js';
import '../Icons/FileIcon.js';
import '../Icons/FileSearchIcon.js';
import '../Icons/FileType2Icon.js';
import '../Icons/FilmIcon.js';
import '../Icons/FitscreenIcon.js';
import '../Icons/FocusIcon.js';
import '../Icons/FolderAddIcon.js';
import '../Icons/FolderClosedIcon.js';
import '../Icons/FolderIcon.js';
import '../Icons/FutureIcon.js';
import '../Icons/GalleryVerticalEndIcon.js';
import '../Icons/GridIcon.js';
import '../Icons/HelpIcon.js';
import '../Icons/HistoryIcon.js';
import '../Icons/HomeIcon.js';
import '../Icons/InformationIcon.js';
import '../Icons/InstagramIcon.js';
import '../Icons/LibraryIcon.js';
import '../Icons/LightbulbIcon.js';
import '../Icons/LinkedinIcon.js';
import '../Icons/ListIcon.js';
import '../Icons/ListSearchIcon.js';
import '../Icons/Loader2Icon.js';
import '../Icons/LockAltIcon.js';
import '../Icons/LockAltOpenIcon.js';
import '../Icons/LockIcon.js';
import '../Icons/LockOpenIcon.js';
import '../Icons/MagazineIcon.js';
import '../Icons/MailIcon.js';
import '../Icons/Maximize2Icon.js';
import '../Icons/MenuCollapsable2Icon.js';
import '../Icons/MenuCollapsableIcon.js';
import '../Icons/MenuDotsIcon.js';
import '../Icons/MenuIcon.js';
import '../Icons/MinusIcon.js';
import '../Icons/NewsIcon.js';
import '../Icons/NtfrIcon.js';
import '../Icons/OkCircleIcon.js';
import '../Icons/OkIcon.js';
import '../Icons/PencilIcon.js';
import '../Icons/PenSquareIcon.js';
import '../Icons/People2Icon.js';
import '../Icons/PeopleIcon.js';
import '../Icons/PersonIcon.js';
import '../Icons/PhoneCallIcon.js';
import '../Icons/PlayFilledIcon.js';
import '../Icons/PlayIcon.js';
import '../Icons/PlusCircleIcon.js';
import '../Icons/PlusIcon.js';
import '../Icons/PlusSquareIcon.js';
import '../Icons/PrintIcon.js';
import '../Icons/RadioIcon.js';
import '../Icons/RefreshCwIcon.js';
import '../Icons/RotateIcon.js';
import '../Icons/SearchIcon.js';
import '../Icons/SettingsIcon.js';
import '../Icons/ShareIcon.js';
import '../Icons/ShieldIcon.js';
import '../Icons/SocialXIcon.js';
import '../Icons/StarFilledIcon.js';
import '../Icons/StarOutlineIcon.js';
import '../Icons/StickyNoteIcon.js';
import '../Icons/SwapHorizontalIcon.js';
import '../Icons/TablePropertiesIcon.js';
import '../Icons/TasklistIcon.js';
import '../Icons/ThumbDownIcon.js';
import '../Icons/ThumbsDownIcon.js';
import '../Icons/ThumbsUpIcon.js';
import '../Icons/ThumbUpIcon.js';
import '../Icons/TimeIcon.js';
import '../Icons/TimerIcon.js';
import '../Icons/Trash2Icon.js';
import '../Icons/TrashIcon.js';
import '../Icons/UpgradeIcon.js';
import '../Icons/UploadIcon.js';
import '../Icons/UserIcon.js';
import '../Icons/VideoIcon.js';
import '../Icons/WorldIcon.js';
import '../Icons/XposiIcon.js';
import '../Icons/YoutubeIcon.js';
import { List } from '../List/List.js';
import { ListItem } from '../List/ListItem.js';
import { ListItemBaseLi } from '../List/ListItemBase.js';
import { ListLinkItem } from '../List/ListLinkItem.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { BreadcrumbSeparator } from './BreadcrumbSeparator.js';

const StyledOrderedList = styled(List).withConfig({
  componentId: "sc-167eh17-0"
})(["", "{display:none;a{padding:0 ", ";", "}", "}", ":first-child{display:flex;", "}"], ListItemBaseLi, spacing(1), keyboardFocusOutline({
  hasReset: true,
  offset: -2
}), media.greaterThan('s')`
      display: flex;
      
      > span {
        flex: 1 0 auto;
      }

      &:not(:first-child) {
        overflow: hidden;

        a {
          ${defaultStyles.ellipsis};
        }
      }
    `, ListItemBaseLi, media.greaterThan('s')`
      display: none;
    `);
const MobileBreadcrumbItem = /*#__PURE__*/withTitan(({
  to,
  label,
  testId
}) => jsx(ListLinkItem, {
  linkTo: to,
  prefixAdornment: jsx(ChevronLeftIcon, {}),
  testId: testId,
  children: label
}), {
  name: 'MobileBreadcrumbItem'
});
const Breadcrumb = /*#__PURE__*/withTitan(({
  labelNav = 'Breadcrumb',
  labelExpand = 'Breadcrumb uitklappen',
  separator,
  collapse = {},
  spaceAfter,
  spaceBetween = 1,
  items,
  testId = 'breadcrumb'
}) => {
  const [isExpanded, setExpanded] = useState(false);
  const {
    itemsBefore = 1,
    itemsAfter = 1,
    max = 4
  } = collapse;
  const totalItems = items.length;
  // If the last item has no destination, we want to use the one before that
  const lastItemWithTo = items[totalItems - 1].to ? items[totalItems - 1] : items[totalItems - 2];
  const hasConfig = Object.keys(collapse).length;
  const shouldCollapse = hasConfig && !isExpanded && totalItems > max;
  const breadcrumbs = items.map(({
    to,
    label
  }, index) => jsxs(React.Fragment, {
    children: [!!index && jsx(BreadcrumbSeparator, {
      separator: separator
    }), to ? jsx(ListLinkItem, {
      linkTo: to,
      testId: `${testId}ItemDesktop`,
      children: label
    }) : jsx(ListItem, {
      testId: `${testId}ItemDesktopStatic`,
      children: label
    })]
  }, `breadcrumb-item-desktop-${index}`));
  if (shouldCollapse) {
    const beforeItems = breadcrumbs.slice(0, itemsBefore);
    const afterItems = breadcrumbs.slice(totalItems - itemsAfter, totalItems);
    return jsx("nav", {
      "aria-label": labelNav,
      children: jsxs(StyledOrderedList, {
        "data-test-id": testId,
        spaceAfter: spaceAfter,
        spaceBetween: spaceBetween,
        type: "ol",
        variant: "horizontal-start",
        children: [lastItemWithTo && jsx(MobileBreadcrumbItem, Object.assign({
          testId: `${testId}ItemMobile`
        }, lastItemWithTo)), jsxs(Fragment, {
          children: [beforeItems, itemsBefore === 1 && jsx(BreadcrumbSeparator, {
            separator: separator
          }), jsxs(ListLinkItem, {
            onClick: () => setExpanded(true),
            children: [jsx(VisuallyHidden, {
              children: labelExpand
            }), "..."]
          }), afterItems]
        })]
      })
    });
  }
  return jsx("nav", {
    "aria-label": labelNav,
    children: jsxs(StyledOrderedList, {
      "data-test-id": testId,
      spaceAfter: spaceAfter,
      spaceBetween: spaceBetween,
      variant: "horizontal-start",
      children: [lastItemWithTo && jsx(MobileBreadcrumbItem, Object.assign({
        testId: `${testId}ItemMobile`
      }, lastItemWithTo)), breadcrumbs]
    })
  });
}, {
  name: 'Breadcrumb'
});

export { Breadcrumb };
//# sourceMappingURL=Breadcrumb.js.map
